var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 55,
    viewBox: "0 0 85 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7439 53.608L6.02729 41.7532C4.00998 41.044 3.99953 38.1948 6.01158 37.4707L42.6574 24.2832C43.1655 24.1004 43.722 24.1044 44.2273 24.2945L79.2802 37.4822C81.2514 38.2238 81.2408 41.0159 79.264 41.7425L47.1262 53.5558C44.7463 54.4306 42.136 54.449 39.7439 53.608Z",
    stroke: "#00FF94",
    strokeWidth: 0.737374
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6208 50.7408L10.4272 40.8768C9.16172 40.4766 9.15569 38.6879 10.4185 38.2792L42.8733 27.7752C43.1521 27.685 43.4526 27.687 43.7302 27.7809L74.7741 38.285C76.0141 38.7045 76.008 40.4605 74.7651 40.8714L44.9775 50.7189C43.8887 51.0789 42.7142 51.0865 41.6208 50.7408Z",
    fill: "#203376"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2685 38.9751L63 31.0063L60.8016 34.7984L31.0562 42.9103L33.2685 38.9751Z",
    fill: "#00CC76",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2665 9.24365L33.2686 38.9751L31.0562 42.9103L21.0001 12.4039L23.2665 9.24365Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63 31.0062L52.9979 1L23.2664 9.24345L33.2685 38.9749L63 31.0062Z",
    fill: "white",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2676 34.347L40.5636 4.43799L36.1023 5.69411L45.817 35.5582L50.2676 34.347Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4806 38.1042L50.2676 34.3467L45.817 35.558L43.6075 39.4845L48.4806 38.1042Z",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4502 28.9695C43.1572 28.0907 43.3281 22.6692 43.4502 20.0683L41.9573 19.1387C39.7602 19.2795 38.6616 29.3638 39.6194 28.9695C40.3855 28.654 42.3798 28.8381 43.4502 28.9695Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2003 27.1487C47.4638 26.9469 44.4848 22.1871 43.4501 21.0706L45.04 19.5938C48.5167 21.5573 51.3111 24.8346 51.5518 25.6431C50.4448 26.904 48.9368 27.3506 48.2003 27.1487Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5214 19.9046C28.8816 17.2037 36.0904 17.5049 39.5893 18.1461L41.9639 19.3666L40.9821 21.6044C31.9016 31.9524 33.3381 24.5441 30.5214 19.9046Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0195 21.2827C37.2849 22.0816 32.043 24.4796 33.5083 26.3963C34.9735 28.313 39.6061 23.488 41.0195 21.2827Z",
    fill: "#00834C",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3728 12.0756C52.0494 12.0987 46.4581 15.5407 44.1865 17.0422C42.1796 17.4657 44.0417 19.8259 44.4031 20.0308C46.8862 21.4392 55.015 21.9655 55.2027 20.464C55.8669 13.7214 52.7771 12.0466 52.3728 12.0756Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9102 20.5942C48.1366 21.3103 55.96 22.3023 55.1964 19.7717C54.8487 17.0103 48.2271 19.3855 45.9102 20.5942Z",
    fill: "#00834C",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0886 19.3978L45.637 17.7662C45.4491 17.0873 44.9323 16.5456 44.2287 16.5781C42.4772 16.659 39.8001 17.4941 39.8449 18.009C39.8811 18.4255 40.4838 19.8586 40.9774 21.0095C41.1911 21.5079 41.578 21.9284 42.0967 22.0865C44.4511 22.8042 45.7169 21.4038 46.1012 20.2841C46.1994 19.9979 46.1693 19.6894 46.0886 19.3978Z",
    fill: "#00FF94",
    stroke: "#03115C",
    strokeWidth: 0.437988,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.3056d46f294df4e9f13c48d46e9ff231.svg";
export { ForwardRef as ReactComponent };